import { z } from 'zod';
import { t } from '@lingui/core/macro';
import { requiredInput } from '@/common/form/requiredInput';
import type { DeviceType } from '@/features/devices/services/schemas';

export const PARENT_NONE = '__none__';

export function makeDeviceFormSchema(deviceTypes: DeviceType[]) {
  return z
    .object({
      name: requiredInput(z.string().max(100)),
      deviceType: requiredInput(z.coerce.number()),
      parent: z.preprocess(
        (val) => (val === PARENT_NONE ? null : val),
        z.coerce.number().nullable()
      ),
    })
    .superRefine((val, ctx) => {
      const selected = deviceTypes.find((t) => t.id === Number(val.deviceType));
      if (selected && selected.deviceGroup.parent !== null && val.parent === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['parent'],
          message: t`Parent device is required for this device type`,
        });
      }
    });
}
